import Icon from 'antd/lib/icon/index'
import 'antd/lib/icon/style/index'

export default Icon
